import { defineStore } from 'pinia';

export type HeadlineState = {
  headline?: string;
  subheadline?: string;
};

export const useHeadlineStore = defineStore('headline', {
  state: (): HeadlineState => ({
    headline: undefined,
    subheadline: undefined,
  }),
  actions: {
    setHeadlines(newHeadlines: Partial<HeadlineState>) {
      this.headline = newHeadlines.headline ?? this.headline;
      this.subheadline = newHeadlines.subheadline ?? this.subheadline;
    },
  },
});
